module.exports = __webpack_public_path__ + "static/media/previous-page.c74711c0.svg";